import { FC } from 'react';

import Header from 'features/Onboarding/components/Header';

import locales from './locales';

interface DraftStatutesHeaderProps {
  isMandatee: boolean;
}
const DraftStatutesHeader: FC<DraftStatutesHeaderProps> = ({ isMandatee }) => (
  <Header
    title={isMandatee ? locales.title.mandatee : locales.title.nonMandate}
  />
);

export default DraftStatutesHeader;
